import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import { config } from '../../../utility/swaggerClient';
import { Link } from 'react-router-dom';
import NPUserView from './NPUserView';
import axios from 'axios';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'project.management.html.header',
    description: 'Page Header Title',
    defaultMessage: 'PROJECT MANAGEMENT'
  },
  headerSubTitle: {
    id: 'project.management.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Project Home'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

// let repos = [];

class ProjectManagement extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showDetail: false,
      showDetailSent: false,
      refreshbtn: true,
      ref: '',
      srcstatus: '',
      reponame: '',
      srclang: '',
      tgtlang: '',
      jobType: '',
      jobStatus: '',
      description: '',
      customer: '',
      stagingrepo: '',
      detailpage: '',
      repos: [],
      organization: '',
      dataFactory: '',
      project: '',
      updatebtn: true,
      projectId: -1,
      applicationName: '',
      disableDataPipelineBtn: true,
      hasDesignFile: false,
      disableGenerateSourceBtn: true,
      buildbtn: false,
      tag: ""
    };

    this.NPselectItem = this.NPselectItem.bind(this);
    this.updateItemClicked = this.updateItemClicked.bind(this);
    this.viewSTM = this.viewSTM.bind(this);
    this.viewDataPipeline = this.viewDataPipeline.bind(this);
    this.viewSourCode = this.viewSourCode.bind(this);
    this.generateAndTestClicked = this.generateAndTestClicked.bind(this);
    this.generateSourceClicked = this.generateSourceClicked.bind(this);
    this.uploadDesignClicked = this.uploadDesignClicked.bind(this);
  }

  generateSourceClicked() {
    this.props.history.push({
      pathname: `/en-CA/codeview`,
      state: [
        {
          dataFactory: this.state.dataFactory,
          dataFactoryId: this.state.dataFactoryId,
          companyname: this.state.companyname,
          customer: this.state.customer,
          project: this.state.project,
          applicationName: this.state.applicationName
        }
      ]
    });
  }

  uploadDesignClicked() {
    this.props.history.push({
      pathname: '/en-CA/projectmanagement/uploaddesign/' +
      this.state.dataFactory +
      '/' +
      this.state.projectId +
      '/' +
      this.state.dataFactoryId +
      '/' +
      this.state.customer +
      '/' +
      this.state.customer +
      '/' +
      this.state.project +
      '/' +
      this.state.applicationName,

    });
  }

  updateItemClicked() {
    console.log('update click');
    console.log(this.state);
    console.log(this.props);
    this.props.history.push({
      pathname: `/en-CA/projectmanagement/${this.state.dataFactory}/${
        this.state.projectId
      }/${this.state.dataFactoryId}/${this.state.customer}`,
      state: [
        {
          customer: this.state.customer
        }
      ]
    });
    // this.props.history.push(`/en-CA/projectmanagement/${this.state.dataFactory}/${this.state.projectId}/${this.state.dataFactoryId}` )
  }

  generateAndTestClicked() {
    console.log('generateAndTestClicked')
    console.log(this.props)
    this.props.history.push({
      pathname: '/en-CA/generateTestsource/' +
      this.state.dataFactory +
      '/' +
      this.state.project +
      '/' +
      this.state.dataFactoryId +
      '/' +
      this.state.projectId +
      '/' +
      this.state.customer,
      state: [
        {
          customer: this.state.customer
        }
      ]
    });
  }

  viewSTM() {
    console.log('Sherman View STM');
    this.props.history.push({
      pathname: `/en-CA/projectmanagement/viewstm/${this.state.dataFactory}/${
        this.state.projectId
      }/${this.state.dataFactoryId}`,
      state: [
        {
          customer: this.state.customer
        }
      ]
    });
    // this.props.history.push(`/en-CA/projectmanagement/viewstm/${this.state.dataFactory}/${this.state.projectId}/${this.state.dataFactoryId}` )
  }

  viewDataPipeline() {
    console.log('view data pipeline click');
    return;
    //this.props.history.push(`/en-CA/datapipeline/${this.state.dataFactory}/${this.state.dataFactoryId}/${this.state.project}/${this.state.project}/${this.state.customer}`)
  }

  viewSourCode() {
    this.props.history.push(
      `/en-CA/codeview/${this.state.dataFactory}/${this.state.dataFactoryId}/${
        this.state.project
      }/${this.state.project}/${this.state.customer}`
    );
  }

  releaseValidation = (prj)=>{
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    // let prj =  this.state.project;
    let datafacotry = this.state.dataFactory;
    let customerid = this.state.customer;
    let dataFactoryId = this.state.dataFactoryId;
    fetch(`${config.protocol}://${config.host}/api/project/releasevalidation/`+ customerid + '/' + datafacotry + '/' + prj + '/' + dataFactoryId, requestOptions).then((response)=>{
      return response.json();
    }).then((res)=>{
      if(res.code === 200){
        this.setState({buildbtn : true, tag: res.data});
      }else{
        this.setState({buildbtn : false});
      }
    })
  }

  selectItem = value => {
    console.log('select item start');
    console.log(value);
    this.setState({
      ref: value.referenceId,
      srcstatus: value.sourcestatus,
      reponame: value.reponame,
      srclang: value.srclang,
      tgtlang: value.tgtlang,
      jobType: value.jobType,
      jobStatus: value.jobStatus,
      description: value.description,
      stagingrepo: '',
      buildbtn : false
    });

    this.releaseValidation(this.state.project);
  };

  nprefresh = () => {
    // let cus = this.state.customer;
    window.location.reload();
    // this.props.NPRequestList(this.state.customer)
  };

  updateItem = project => {
    console.log('update start');
    console.log(project);
  };

  NPselectItem = value => {
    console.log('NP select item start');
    console.log(value);
    this.setState({
      project: value.projectName,
      updatebtn: false,
      projectId: value.id,
      applicationName: value.applicationName,
      buildbtn : false
    });

    this.releaseValidation(value.projectName);

    console.log('showme set state');
    console.log(this.state);
    console.log('showme set props');
    console.log(this.props);
    this.setState({ customer: this.state.customer });
    if (this.props.customerid !== null) {
      console.log('run here');
      console.log(this.props.customerid);
      this.setState({ customer: this.props.customerid });
    }
    let customerValue =
      this.props.customerid === null
        ? this.state.customer
        : this.props.customerid;

    axios
        .get(
          `${config.protocol}://${
            config.host
          }/api/user/generatedCode/${customerValue}/${this.state.dataFactory}/${
            value.projectName
          }`
        )
        .then(response => {
          console.log('response data');
          console.log(response.data.data);
          this.setState({ disableGenerateSourceBtn: false });
        })
        .catch(error => {
          console.log('call error');
          this.setState({ disableGenerateSourceBtn: true });
        });

    axios
      .get(
        `${config.protocol}://${
          config.host
        }/api/project/getDesignDSL/${customerValue}/${this.state.dataFactory}/${
          value.projectName
        }`
      )
      .then(response => {
        console.log('response data');
        console.log(response.data.data);
        this.setState({ disableDataPipelineBtn: false });
      })
      .catch(error => {
        console.log('call error');
        this.setState({ disableDataPipelineBtn: true });
      });


      let project = {
        projectId: value.projectId,
        projectName: value.projectName
      }

      axios
        .post(
          `${config.protocol}://${config.host}/api/project/hasDesignFile`,
          project
        )
        .then(response => {
          console.log('response hasDesignFile:' + response.data);
          console.log(response.data === true)
          this.setState({hasDesignFile: response.data})

        })
  };



  getStagingrepos = () => {
    let repos = [];
    this.props.releasestagingprojectList.map(item =>
      repos.push({ value: item, checked: false })
    );
    console.log(repos);
    this.setState({ repos: repos });
  };

  repoCallback = () => {
    let temp = '';
    this.state.repos.forEach(r => {
      if (r.checked) {
        temp += r.value;
        temp += ',';
      }
    });
    if (temp !== '') {
      temp = temp.substring(0, temp.length - 1);
    }
    console.log(temp);

    this.setState({ stagingrepo: temp });
  };

  sourceCodedownload = (customerid, reponame) => {
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('jwt')
      }
    };
    fetch(
      `${config.protocol}://${
        config.host
      }/api/user/download/${customerid}/${reponame}`,
      requestOptions
    )
      .then(response => {
        console.log(response);
        // if(response.status === 200){
        //   throw new Error("woops");
        // }
        return response.blob();
      })
      .then(data => {
        console.log(data);
        const FileDownload = require('js-file-download');
        FileDownload(data, 'Source Code.zip');
      })
      .catch(err => console.log(err));
  };

  TranslatedCodedownload = (ref, type) => {
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('jwt')
      }
    };
    fetch(
      `${config.protocol}://${
        config.host
      }/api/user/translationcode/${type}/${ref}`,
      requestOptions
    )
      .then(response => response.blob())
      .then(data => {
        const FileDownload = require('js-file-download');
        FileDownload(data, 'Translated Code.zip');
      });
  };

  reportdownload = (ref, type) => {
    console.log(this.state.stagingrepo);
    console.log(this.state.stagingrepo === '');
    console.log(type);
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('jwt')
      }
    };
    fetch(
      `${config.protocol}://${config.host}/api/user/reports/${type}/${ref}`,
      requestOptions
    )
      .then(response => response.blob())
      .then(data => {
        const FileDownload = require('js-file-download');
        FileDownload(data, 'Report.zip');
      });
  };

  gotoDetail = type => {
    this.setState({ showDetail: true, detailpage: type });
    if (type === 'download') {
      if (this.state.jobType === 'Translation') {
        messages.headerSubTitle.id = 'dashboard.download.translate';
      } else if (
        this.state.jobType === 'Assessment' ||
        this.state.jobType === 'FreeAssessment'
      ) {
        messages.headerSubTitle.id = 'dashboard.download.analyzer';
      }
    } else if (type === 'release') {
      if (this.state.jobType === 'Translation') {
        messages.headerSubTitle.id = 'dashboard.release.translate2';
      } else if (
        this.state.jobType === 'Assessment' ||
        this.state.jobType === 'FreeAssessment'
      ) {
        messages.headerSubTitle.id = 'dashboard.release.analyzer2';
      }
    }
  };

  selectDataFactory = e => {
    console.log('Test ' + e.target.value);
    console.log('Test ' + e.target.options.selectedIndex);
    console.log(
      e.target.options[e.target.options.selectedIndex].getAttribute('id')
    );

    if (e.target.value === null || e.target.value === '') {
      return;
    }
    this.props.dataFactoryTable(
      e.target.options[e.target.options.selectedIndex].getAttribute('id')
    );
    this.setState({
      dataFactory: e.target.value,
      updatebtn: true,
      dataFactoryId: e.target.options[
        e.target.options.selectedIndex
        ].getAttribute('id')
    });
    console.log(this.state);
  };

  selectCus = e => {
    this.props.customersList.forEach(item => {
      if (e.target.value === item['customer_id']) {
        this.setState({
          customer: e.target.value,
          organization: item['company_name']
        });
      }
    });

    this.setState({
      dataFactory: '',
      dataFactoryId: ''
    });

    this.props.getDataFactoryList(e.target.value);

  };

  componentDidUpdate() {
    console.log('componentDidUpdate');
    console.log(this.props);
    console.log(this.state);
  }

  confirmation = () => {};
  confirmationSubmit = () => {
    if (this.props.role.includes('CUSTOMER_ADMIN')) {
      const callback = () => this.props.RequestList(this.props.username);
      this.props.deletesrccode(
        this.props.customerid,
        this.state.reponame,
        callback
      );
    } else {
      const callback = () => this.props.NPRequestList(this.state.customer);
      this.props.deletesrccode(
        this.state.customer,
        this.state.stagingrepo,
        callback
      );
    }
  };
  submitRequest = () => {
    this.confirmation();
  };
  confirmationText =
    'Your legacy code will be permanently deleted from our system in 5 business days. Do you want to delete?   <br /><br />';

  componentDidMount() {
    console.log('componentDidMount call');
    this.props.getCustomers();

    this.setState({
      dataFactory: this.props.match.params.dataFactory,
      dataFactoryId: this.props.match.params.dataFactoryId
    });
    // }
    console.log(this.props);
    if (
      this.props.match.url !== '/en-CA/projectmanagement' &&
      this.props.location.state != undefined
    ) {
      this.props.getDataFactoryList(this.props.location.state[0].customer);
      this.props.dataFactoryTable(this.props.match.params.dataFactoryId);
      console.log('inside if call');
      console.log(this.props.location.state[0].companyname);
      console.log(this.props.location.state[0].customer);
      this.setState({
        organization: this.props.location.state[0].companyname,
        customer: this.props.location.state[0].customer
      });
    } else if (this.props.match.url.indexOf('back') > -1) {
      console.log('inside back call');
      this.setState({
        //organization: this.props.location.state[0].companyname,
        customer: this.props.match.params.customer
      });

    } else {
      console.log('inside else call');
      if (
        this.props.role.includes('PROFESSIONAL_SERVICE') ||
        this.props.role.includes('SALESMAN_ENGINEER')
      ) {
        console.log('inside another if');
        this.props.getDataFactoryList(this.props.customerid);
      } else this.props.getDataFactoryList('-1');
    }
  }

  render() {
    // if(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER')){
    return (
      <div className="preview page">
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status={this.props.status}
        />

        <div className="main">
          {this.state.showDetail && (
            <div
              className="panel"
              style={{
                width: '95%',
                padding: '40px',
                boxSizing: 'content-box',
                // marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.showDetailSent && (
                <div>
                  <label
                    style={{
                      width: '90%',
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: '150%'
                    }}
                  >
                    You have successfully released
                    {this.state.jobType === 'Translation' &&
                    ' the translated target code for the commercial code translation '}
                    {this.state.jobType === 'Assessment' &&
                    ' the analyzer report '}
                    for:
                    <br />
                    <br />
                    Customer name:{' '}
                    {/*{this.props.customersList.filter(item => this.state.customer === item["customer_id"])*/}
                    {/*.map(item => (item["company_name"]))}*/}
                    {this.state.organization}
                    <br />
                    <br />
                    Project name: {this.state.reponame}
                    <br />
                    <br />
                    Staging project:
                    {this.state.stagingrepo.split(',').map((stag, index) => (
                      <p key={index} style={{ paddingLeft: '15px' }}>
                        {stag}
                      </p>
                    ))}
                    <br />
                    <br />A notification email will be sent to the customer.
                  </label>
                  <br />
                  &nbsp;
                  <br />
                  &nbsp;
                  <div
                    className="button-container"
                    style={{ textAlign: 'center' }}
                  >
                    <button
                      className="button"
                      styel={{ padding: 20 }}
                      type="button"
                      onClick={() => window.location.reload()}
                    >
                      <FormattedMessage id="nav.ok" defaultMessage="OK" />
                    </button>
                  </div>
                </div>
              )}

              {!this.state.showDetailSent && (
                <LocalForm className="form">
                  <div
                    style={{
                      marginLeft: '3%'
                    }}
                  >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage id="onboard.organization" />
                      </label>

                      <Control.text
                        model=".customer"
                        value={this.state.organization}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage id="source.code.repository.name" />
                      </label>

                      <Control.text
                        model=".reponame"
                        defaultValue={this.state.reponame}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage id="assessment.stagingname" />
                      </label>

                      <Control.text
                        model=".stagingrepo"
                        value={this.state.stagingrepo}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="dashboard.referenceid"
                          defaultMessage="Reference ID: "
                        />
                      </label>

                      <Control.text
                        model=".customer"
                        defaultValue={this.state.ref}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="projects.project.source-languagee"
                          defaultMessage="Source Language: "
                        />
                      </label>

                      <Control.text
                        model=".srclang"
                        value={this.state.srclang}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="projects.project.target-language"
                          defaultMessage="Target Language: "
                        />
                      </label>

                      <Control.text
                        model=".tgtlang"
                        value={this.state.tgtlang}
                        disabled
                      />
                    </fieldset>

                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="comments.name"
                          defaultMessage="Description"
                        />
                      </label>

                      <Control.text
                        model=".description"
                        value={this.state.description}
                        disabled
                      />
                    </fieldset>

                    <div
                      className="button-container"
                      style={{ textAlign: 'center' }}
                    >
                      <button
                        className="button"
                        type="button"
                        style={{ marginRight: '10px' }}
                        onClick={this.showDetailFalse}
                      >
                        <FormattedMessage
                          id="run-assessment.back.button.name"
                          defaultMessage="Back"
                        />
                      </button>

                      {this.state.detailpage === 'download' &&
                      this.state.jobType === 'Translation' && (
                        <button
                          className="button"
                          type="button"
                          onClick={() =>
                            this.state.stagingrepo === ''
                              ? this.TranslatedCodedownload(
                              this.state.ref,
                              'translation'
                              )
                              : this.TranslatedCodedownload(
                              this.state.ref,
                              'internal_translation'
                              )
                          }
                        >
                          <FormattedMessage
                            id="dashboard.download.translate"
                            defaultMessage="DOWNLOAD TRANSLATED CODE"
                          />
                        </button>
                      )}

                      {this.state.detailpage === 'release' &&
                      this.state.jobType === 'Translation' && (
                        <button
                          className="button"
                          type="button"
                          onClick={() =>
                            this.props.approvetranslation(
                              this.props.username,
                              this.state.reponame,
                              this.state.srclang,
                              this.state.tgtlang,
                              this.state.description,
                              this.state.jobType,
                              this.state.stagingrepo,
                              this.state.customer,
                              this.state.ref,
                              this.showDetailSentTrue
                            )
                          }
                          disabled={this.state.stagingrepo === ''}
                        >
                          <FormattedMessage
                            id="dashboard.release.translate"
                            defaultMessage="DOWNLOAD TRANSLATED CODE"
                          />
                        </button>
                      )}

                      {this.state.detailpage === 'release' &&
                      (this.state.jobType === 'Assessment' ||
                        this.state.jobType === 'FreeAssessment') && (
                        <button
                          className="button"
                          type="button"
                          onClick={() =>
                            this.props.approveassessment(
                              this.props.username,
                              this.state.reponame,
                              this.state.srclang,
                              this.state.tgtlang,
                              this.state.description,
                              this.state.jobType,
                              this.state.stagingrepo,
                              this.state.customer,
                              this.state.ref,
                              this.showDetailSentTrue
                            )
                          }
                          disabled={this.state.stagingrepo === ''}
                        >
                          <FormattedMessage
                            id="dashboard.release.analyzer"
                            defaultMessage="DOWNLOAD TRANSLATED CODE"
                          />
                        </button>
                      )}

                      {this.state.detailpage === 'download' &&
                      (this.state.jobType === 'Assessment' ||
                        this.state.jobType === 'FreeAssessment') && (
                        <button
                          className="button"
                          type="button"
                          onClick={() =>
                            this.state.stagingrepo === ''
                              ? this.reportdownload(
                              this.state.ref,
                              'assessment'
                              )
                              : this.reportdownload(
                              this.state.ref,
                              'internal_assessment'
                              )
                          }
                        >
                          <FormattedMessage
                            id="dashboard.download.analyzer"
                            defaultMessage="DOWNLOAD TRANSLATED CODE"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </LocalForm>
              )}
            </div>
          )}

          {!this.state.showDetail && (
            <div
              className="panel"
              style={{
                width: '95%',
                boxSizing: 'content-box',
                // marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {

                (this.props.role.includes('TRANSLATION_LEAD') ||
                  this.props.role.includes('DATA_ENGINEER')) ? (
                    <div className="form">
                      <fieldset
                        style={{ padding: '20px', width: 'auto', float: 'none' }}
                      >
                        {/* {
                   (this.props.role.includes('TRANSLATION_LEAD'))   && */}
                        <div>
                          <label style={{ textTransform: 'capitalize' }}>
                            <FormattedMessage
                              id="dashboard.customer"
                              defaultMessage="Organization Name: "
                            />
                          </label>

                          <Control.select
                            model=".customer"
                            autoFocus
                            required
                            value={this.state.customer}
                            onChange={this.selectCus}
                          >
                            {this.state.customer === '' && (
                              <option value="">
                                Please select organization name
                              </option>
                            )}
                            {this.props.customersList.map(item => (
                              <option
                                key={item['customer_id']}
                                value={item['customer_id']}
                              >
                                {item['company_name']}
                              </option>
                            ))}
                          </Control.select>
                        </div>

                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.data.factory.name"
                            defaultMessage="Data Factory Name: "
                          />
                        </label>

                        <Control.select
                          model=".customer"
                          autoFocus
                          required
                          value={this.state.dataFactory}
                          onChange={this.selectDataFactory}
                        >
                          {<option value="">Please select data factory</option>}
                          {/* {this.props.customersList.map(item => (
                        <option key={item["customer_id"]} value={item["customer_id"]}>
                          {item["company_name"]}
                        </option>
                      ))} */}
                          {this.props.dataFactoryList.map(item => (
                            <option
                              id={item['id']}
                              key={item['id']}
                              value={item['name']}
                            >
                              {item['name']}
                            </option>
                          ))}
                        </Control.select>
                      </fieldset>
                      <br />
                      <br />
                      <br />
                      {this.state.dataFactory && (
                        <UserTable
                          data={this.props.dFTable}
                          selectItem={this.NPselectItem}
                          username={this.props.username}
                          userrole={this.props.role}
                        />
                      )}
                    </div>
                  )
                  :
                  (
                    <div className="form">
                      <fieldset
                        style={{ padding: '20px', width: 'auto', float: 'none' }}
                      >
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.data.factory.name"
                            defaultMessage="Data Factory Name: "
                          />
                        </label>

                        <Control.select
                          model=".customer"
                          autoFocus
                          required
                          value={this.state.dataFactory}
                          onChange={this.selectDataFactory}
                        >
                          {<option value="">Please select data factory</option>}
                          {/* {this.props.customersList.map(item => (
                        <option key={item["customer_id"]} value={item["customer_id"]}>
                          {item["company_name"]}
                        </option>
                      ))} */}
                          {this.props.dataFactoryList.map(item => (
                            <option
                              id={item['id']}
                              key={item['id']}
                              value={item['name']}
                            >
                              {item['name']}
                            </option>
                          ))}
                        </Control.select>
                      </fieldset>
                      <br />
                      <br />
                      <br />
                      {this.state.dataFactory && (
                        <UserTable
                          data={this.props.dFTable}
                          selectItem={this.NPselectItem}
                          username={this.props.username}
                          userrole={this.props.role}
                        />
                      )}
                    </div>
                  )
              }


              <br />
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  style={{ marginRight: '10px' }}
                  type="button"
                  onClick={() => this.props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>
                {/* <Link to="/en-CA/projectmanagement/-1"> */}
                <Link
                  to={
                    '/en-CA/projectmanagement/' +
                    this.state.dataFactory +
                    '/-1/' +
                    this.state.dataFactoryId +
                    '/' +
                    this.state.customer
                  }
                >
                  {/* <Link to= {{
                    pathname:'/en-CA/projectmanagement/' + this.state.dataFactory + '/-1/' + this.state.dataFactoryId + '/' + this.state.customer ,
                    //state:[{ customer:this.state.customer}]
                  }}> */}
                  <button
                    className="button"
                    style={{ marginRight: '10px' }}
                    type="button"
                    // onClick={() => this.props.NPRequestList(this.state.customer)}
                    //disabled={this.state.refreshbtn}
                    // onClick={() => this.nprefresh()}
                  >
                    CREATE
                  </button>
                </Link>

                <button
                  className="button"
                  style={{ marginRight: '10px' }}
                  type="button"
                  onClick={this.updateItemClicked}
                  disabled={this.state.updatebtn}
                >
                  UPDATE
                </button>

                <button
                  className="button"
                  style={{ marginRight: '10px' }}
                  type="button"
                  //onClick={() => this.props.NPRequestList(this.state.customer)}
                  disabled={this.state.updatebtn}
                  onClick={this.viewSTM}
                >
                  VIEW STM
                </button>
                {!this.state.disableDataPipelineBtn && (
                  <span>
                    <Link
                      to={{
                        pathname: `/en-CA/datapipeline`,
                        state: [
                          {
                            dataFactory: this.state.dataFactory,
                            dataFactoryId: this.state.dataFactoryId,
                            companyname: this.state.organization,
                            customer: this.state.customer,
                            project: this.state.project,
                            applicationName: this.state.applicationName
                          }
                        ]
                      }}
                      onClick={this.viewDataPipeline}
                    >
                      <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                        disabled={this.state.disableDataPipelineBtn}
                      >
                        VIEW DATA PIPELINE
                      </button>
                    </Link>

                    {/* <Link
                      to={{
                        pathname: `/en-CA/codeview`,
                        state: [
                          {
                            dataFactory: this.state.dataFactory,
                            dataFactoryId: this.state.dataFactoryId,
                            companyname: this.state.companyname,
                            customer: this.state.customer,
                            project: this.state.project,
                            applicationName: this.state.applicationName
                          }
                        ]
                      }}
                    > */}
                      {/* {(this.props.role.includes('PROFESSIONAL_SERVICE') ||
                      this.props.role.includes('CUSTOMER_ADMIN')) && ( */}
                      <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                        disabled={this.state.disableDataPipelineBtn}
                        onClick={this.generateAndTestClicked}
                      >
                        GENERATE & TEST
                      </button>
                      {/* )} */}

                      <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                        disabled={this.state.disableGenerateSourceBtn}
                        onClick={this.generateSourceClicked}
                      >
                        VIEW SOURCE CODE
                      </button>
                    {/* </Link> */}
                  </span>
                )}

                {this.state.disableDataPipelineBtn && (
                  <span>
                    <button
                      className="button"
                      style={{ marginRight: '10px' }}
                      type="button"
                      disabled={this.state.disableDataPipelineBtn}
                    >
                      VIEW DATA PIPELINE
                    </button>

                    <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                        disabled={this.state.disableDataPipelineBtn}
                        onClick={this.generateAndTestClicked}
                      >
                        GENERATE & TEST
                      </button>

                    <button
                      className="button"
                      style={{ marginRight: '10px' }}
                      type="button"
                      disabled={this.state.disableGenerateSourceBtn}

                    >
                      VIEW SOURCE CODE
                    </button>             
                  </span>
                )}
              </div>
              {!this.props.role.includes('PROFESSIONAL_SERVICE') &&
              !this.props.role.includes('SALESMAN_ENGINEER') && 
              !this.props.role.includes('CUSTOMER_ADMIN') && (
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    style={{ marginRight: '10px' }}
                    type="button"
                    disabled={this.state.updatebtn}
                  >
                    DESIGN
                  </button>
                  {/* <Link
                    to={
                      '/en-CA/projectmanagement/uploaddesign/' +
                      this.state.dataFactory +
                      '/' +
                      this.state.projectId +
                      '/' +
                      this.state.dataFactoryId +
                      '/' +
                      this.state.customer +
                      '/' +
                      this.state.customer +
                      '/' +
                      this.state.project +
                      '/' +
                      this.state.applicationName
                    }
                  > */}
                    <button
                      className="button"
                      style={{ marginRight: '10px' }}
                      type="button"
                      disabled={this.state.updatebtn}
                      onClick={this.uploadDesignClicked}
                    >
                      UPLOAD DESIGN
                    </button>
                  {/* </Link> */}
                  {/* <Link to = {'/en-CA/generateTestsource/' + this.state.dataFactory + '/' + this.state.project + '/' + this.state.dataFactoryId + '/' + this.state.projectId}> */}



                    {/* <Link to = {'/en-CA/generateTestsource/' + this.state.dataFactory + '/' + this.state.project + '/' + this.state.dataFactoryId + '/' + this.state.projectId}> */}
                    {/* <Link
                      to={{
                        pathname:
                          '/en-CA/generateTestsource/' +
                          this.state.dataFactory +
                          '/' +
                          this.state.project +
                          '/' +
                          this.state.dataFactoryId +
                          '/' +
                          this.state.projectId +
                          '/' +
                          this.state.customer,
                        state: [
                          {
                            customer: this.state.customer
                          }
                        ]
                      }}
                    > */}
                      <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                        disabled={!this.state.hasDesignFile}
                        onClick={this.generateAndTestClicked}
                      >
                        GENERATE & TEST
                      </button>
                    {/* </Link> */}
                    {/* <button
                    className="button"
                    style={{ marginRight: '10px' }}
                    type="button"
                    disabled={this.state.updatebtn }
                  >
                   BUILD
                  </button> */}

                  {!this.state.buildbtn && (
                    <button
                      className="button"
                      style={{ marginRight: '10px' }}
                      type="button"
                      disabled
                    >
                      BUILD & RELEASE
                    </button>
                  )}
                  {this.state.buildbtn && (
                    <Link
                      to={{
                        pathname: `/en-CA/buildcode`,
                        state: [
                          {
                            dataFactory: this.state.dataFactory,
                            dataFactoryId: this.state.dataFactoryId,
                            companyname: this.state.organization,
                            customer: this.state.customer,
                            project: this.state.project,
                            applicationName: this.state.applicationName,
                            tag: this.state.tag
                          }
                        ]
                      }}
                    >
                      <button
                        className="button"
                        style={{ marginRight: '10px' }}
                        type="button"
                      >
                        BUILD & RELEASE
                      </button>
                    </Link>
                  )}
                </div>
              )}

              <br />
              <br />
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
    // }
  }
}

ProjectManagement.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(ProjectManagement);



// WEBPACK FOOTER //
// ./src/components/views/ProjectManagement/index.js